import DevExtremeTreeList from 'components/inheritComponent/devextremetreelist'
import { getUser } from 'dataSource/lookup'
import { Form } from 'devextreme-react'
import { Popup } from 'devextreme-react/popup'
import React, { Component } from 'react'
import httpRequest from 'plugin/httprequest'
import { showLoading } from 'redux/actions/loading'
import uuidv4 from 'uuid/v4'

class ModalAksesMenu extends Component {
  constructor(props) {
    super(props)
    this.state = {
      popupVisible: false,
      formData: {},
    }

    this.formItem = [
      {
        dataField: 'username',
        label: {
          alignment: 'left',
          text: 'Username',
        },
        editorOptions: {
          elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
        },
      },
      {
        dataField: 'userParentId',
        label: {
          text: 'Supervisor',
        },
        editorType: 'dxSelectBox',
        editorOptions: {
          elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
          dataSource: getUser(this.props.store, this.props.participantId),
          valueExpr: 'id',
          displayExpr: 'username',
          searchEnabled: true,
        },
      },
    ]

    this.columns = [
      {
        type: 'buttons',
        buttons: [
          'edit',
          {
            text: 'Aktifkan Menu Anak Dibawahnya',
            hint: 'Aktifkan Menu Anak Dibawahnya',
            cssClass: 'text-success',
            onClick: (e) => {
              this.enableChild(e.row.key)
            },
          },
          {
            text: 'Non Aktifkan Menu Anak Dibawahnya',
            hint: 'Non Aktifkan Menu Anak Dibawahnya',
            cssClass: 'text-success',
            onClick: (e) => {
              this.disableChild(e.row.key)
            },
          },
        ],
      },
      {
        dataField: 'menuCode',
        caption: 'Kode Menu',
        allowEditing: false,
        editorOptions: {
          elementAttr: { class: 'bd-input-popup-dapen-default' },
        },
      },
      {
        dataField: 'menuName',
        caption: 'Nama Menu',
        allowEditing: false,
        editorOptions: {
          elementAttr: { class: 'bd-input-popup-dapen-default' },
        },
      },
      {
        dataField: 'enabled',
        caption: 'Aktif',
        dataType: 'boolean',
      },
    ]

    this.PopupToolbarItem = [
      {
        widget: 'dxButton',
        location: 'after',
        options: {
          text: 'Simpan',
          elementAttr: { class: 'bg-button-popup-save-dapen-default' },
          onClick: () => {
            this.submitData()
          },
        },
        toolbar: 'bottom',
      },
      {
        widget: 'dxButton',
        location: 'after',
        options: {
          text: 'Batal',
          elementAttr: { class: 'bg-button-popup-cancel-dapen-default' },
          onClick: this.hide.bind(this),
        },
        toolbar: 'bottom',
      },
    ]

    this.groupId = 0

    this.formRef = React.createRef()
    this.treelistRef = React.createRef()

    this.dataTreelist = []
  }

  onToolbarPreparing = (e) => {
    e.toolbarOptions.items.unshift(
      {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'todo',
          text: 'Aktifkan Semua Menu',
          elementAttr: { class: 'bg-button-active-dapen-default' },
          onClick: (e) => {
            this.enableAll()
          },
        },
      },
      {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'remove',
          text: 'Non Aktifkan Semua Menu',
          elementAttr: { class: 'bg-button-nonActive-dapen-default' },
          onClick: (e) => {
            this.disableAll()
          },
        },
      }
    )
  }

  retrieveData = async (data) => {
    this.setState({
      formData: data,
    })

    this.groupId = data.id

    var menus = await httpRequest(
      process.env.REACT_APP_BACKEND,
      this.props.store,
      'sys-menu-groups/enabled-multigroup/P-ADM/true'
    )

    var groupMenus = await httpRequest(
      process.env.REACT_APP_BACKEND,
      this.props.store,
      `sys-group-menus`
    )

    groupMenus = groupMenus.filter((value) => value.sysGroupId === this.groupId)

    this.dataTreelist = menus.map((value) => {
      var groupMenu = groupMenus.find(
        (groupValue) => groupValue.sysMenuId === value.id
      )

      return {
        id: groupMenu ? groupMenu.id : uuidv4(),
        sysGroupId: this.groupId,
        sysMenuId: value.id,
        enabled: groupMenu ? groupMenu.enabled : false,
        menuCode: value.menuCode,
        menuName: value.menuName,
        parentCode: value.parentCode,
        level: value.level,
      }
    })

    this.treelistRef.current.forceRefresh(true)
  }

  show = () => {
    this.setState({
      popupVisible: true,
    })
  }

  hide = () => {
    this.setState({
      popupVisible: false,
    })
  }

  loadData = () => {
    return this.dataTreelist
  }

  enableChild = (parentMenuCode) => {
    var data = this.treelistRef.current.getDataSource()

    var parentChanges = {
      type: 'update',
      data: {
        enabled: true,
      },
      key: parentMenuCode,
    }

    var child = data
      .filter((data) => data.menuCode.includes(`${parentMenuCode}-`))
      .map((value) => {
        return {
          type: 'update',
          data: {
            enabled: true,
          },
          key: value.menuCode,
        }
      })

    var changes = [parentChanges, ...child]

    this.treelistRef.current.push(changes)
  }

  disableChild = (parentMenuCode) => {
    var data = this.treelistRef.current.getDataSource()

    var parentChanges = {
      type: 'update',
      data: {
        enabled: false,
      },
      key: parentMenuCode,
    }

    var child = data
      .filter((data) => data.menuCode.includes(`${parentMenuCode}-`))
      .map((value) => {
        return {
          type: 'update',
          data: {
            enabled: true,
          },
          key: value.menuCode,
        }
      })

    var changes = [parentChanges, ...child]

    this.treelistRef.current.push(changes)
  }

  enableAll = () => {
    var data = this.treelistRef.current.getDataSource()

    var changes = data.map((value) => {
      return {
        type: 'update',
        data: {
          enabled: true,
        },
        key: value.menuCode,
      }
    })

    this.treelistRef.current.push(changes)
  }

  disableAll = () => {
    var data = this.treelistRef.current.getDataSource()

    var changes = data.map((value) => {
      return {
        type: 'update',
        data: {
          enabled: false,
        },
        key: value.menuCode,
      }
    })

    this.treelistRef.current.push(changes)
  }

  submitData = async () => {
    this.props.store.dispatch(showLoading(true))
    var datas = this.treelistRef.current.getDataSource()

    for (var data of datas) {
      delete data.parentCode
      delete data.level
      delete data.menuCode
      delete data.menuName

      if (typeof data.id === 'string') {
        delete data.id
        await httpRequest(
          process.env.REACT_APP_BACKEND,
          this.props.store,
          'sys-group-menus',
          'POST',
          {
            values: data,
          }
        )
      } else {
        await httpRequest(
          process.env.REACT_APP_BACKEND,
          this.props.store,
          'sys-group-menus',
          'PUT',
          {
            values: {
              enabled: data.enabled,
            },
            key: data.id,
          },
          data
        )
      }
    }

    this.props.store.dispatch(showLoading(false))

    this.hide()
  }

  onRowUpdating = (e) => {
    var data = this.treelistRef.current.getDataSource()

    var currentRowData = e.oldData

    var currentMenuCodeSegments = currentRowData.parentCode
      ? currentRowData.parentCode.split('-')
      : []

    var menuSameLevelEnabled = data.filter(
      (value) =>
        value.parentCode === currentRowData.parentCode &&
        value.menuCode !== currentRowData.menuCode &&
        value.enabled
    )

    var parentUpdate = e.newData.enabled

    if (menuSameLevelEnabled.length > 0 && !parentUpdate) {
      parentUpdate = true
    }

    var parentMenuCode = ''
    var parent = currentMenuCodeSegments.map((value, index) => {
      parentMenuCode = parentMenuCode + (index === 0 ? '' : '-') + value

      return {
        type: 'update',
        data: {
          enabled: parentUpdate,
        },
        key: parentMenuCode,
      }
    })

    var child = data
      .filter((data) => data.menuCode.includes(`${e.key}-`))
      .map((value) => {
        return {
          type: 'update',
          data: e.newData,
          key: value.menuCode,
        }
      })

    var changes = [...parent, ...child]

    this.treelistRef.current.push(changes)
  }

  render() {
    return (
      <React.Fragment>
        <Popup
          className={'popup'}
          visible={this.state.popupVisible}
          onHiding={this.hide}
          dragEnabled={true}
          showTitle={true}
          title={'User Access'}
          width={'70vw'}
          height={'auto'}
          toolbarItems={this.PopupToolbarItem}
        >
          <Form
            colCount={2}
            id={'formMaster'}
            formData={this.state.formData}
            items={this.formItem}
            ref={this.formRef}
            labelLocation="left"
            readOnly={true}
          />

          <DevExtremeTreeList
            ref={this.treelistRef}
            keyField={'menuCode'}
            parentIdExpr={'parentCode'}
            loadAPI="sys-menus"
            insertAPI="sys-menus"
            updateAPI="sys-menus"
            deleteAPI="sys-menus"
            backendserver={process.env.REACT_APP_BACKEND}
            useNotify={false}
            useArraySource={true}
            ArraySourceData={this.loadData}
            allowAdding={false}
            allowDeleting={false}
            allowUpdating={true}
            editingMode="cell"
            onRowUpdating={this.onRowUpdating}
            exportExcel={false}
            exportFileName={'User Group'}
            allowExportSelectedData={false}
            selection={'none'}
            showBorders={true}
            paging={false}
            defaultPageSize={10}
            popupTitle={'Data Menu'}
            popupWidth={700}
            popupHeight={500}
            height={'calc(70vh - 150px)'}
            popupFormLabelLocation="left"
            popupFormMinColWidth={300}
            popupFormColCount={1}
            ColumnChooser={true}
            ColumnFixing={true}
            FilterRow={true}
            ColumnConfiguration={this.columns}
            SummaryConfiguration={this.summary}
            onToolbarPreparing={this.onToolbarPreparing}
            store={this.props.store}
          />
        </Popup>
      </React.Fragment>
    )
  }
}

export default ModalAksesMenu
